import React from 'react';

import {
  List,
  Datagrid,
  TextField,
  ArrayField,
  SingleFieldList,
  ReferenceArrayInput,
  SelectArrayInput,
} from 'react-admin';

import { Card } from '@mui/material';

import { boldDataGridStyle } from '../../constants/style/datagridStyles';

import NoResults from '../layout/NoResults';
import Pagination from '../layout/Pagination';
import LinkField from '../layout/LinkField';
import ChipStringField from '../../customFields/ChipStringField';
import { ReferenceManyDisplayField } from '../../customFields/EditReferenceManyField';
import SearchField from '../../customFields/SearchField';

export const CarListBody = ({ children }: {children?: React.ReactElement}) => (
  <Datagrid bulkActionButtons={false} sx={boldDataGridStyle} empty={<NoResults variant="h6" />}>
    <LinkField sortable={false} source="id" label="ID" />
    <ArrayField sortable={false} source="customIds" label="Custom IDs">
      <SingleFieldList linkType={false}>
        <ChipStringField />
      </SingleFieldList>
    </ArrayField>
    <ReferenceManyDisplayField
      label="Groups"
      reference="groups"
      source="groups"
    />
    <TextField sortable={false} source="registrationNumber" />
    <TextField sortable={false} source="registrationCountry" />
    <TextField sortable={false} source="carModel" emptyText="-" />
    {children}
  </Datagrid>
);

export const CarFilters = [
  <SearchField source="registrationNumber" alwaysOn />,
  <SearchField source="customId" label="Custom ID" />,
  <ReferenceArrayInput
    page={1}
    perPage={200}
    label="Groups"
    source="groups"
    reference="groups"
    filter={{ active: true }}
  >
    <SelectArrayInput optionText="name" />
  </ReferenceArrayInput>,
  <SearchField source="carModel" />,
  <SearchField source="registrationCountry" />,
];

const CarList = () => (
  <List
    filters={CarFilters}
    sort={{ field: 'createdAt', order: 'DESC' }}
    empty={false}
    pagination={<Pagination disableEmptyText />}
    exporter={false}
  >
    <Card sx={{ margin: 0 }} variant="outlined">
      <CarListBody />
    </Card>
  </List>
);

export default CarList;
